<template>
  <footer class="footer-naotification py-3" v-if="days && days > 0">
    <div class="container">
      <p
        class="text-dark mb-0"
      >{{$lang.messages.your_free_trial_expires_in}} {{days}} {{$lang.messages.days.toLowerCase()}} {{days == 1 ? '' : '(s)'}}.</p>

      <a
        href="/settings/subscription"
        class="text-primary"
      >{{$lang.messages.active_subscription}}</a>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      days: null
    };
  },
  mounted() {
    this.days = localStorage.getItem("days");
  }
};
</script>
